
































import Vue from 'vue';
import ItemIconTooltip from '@/old/items/ItemIconTooltip.vue';
import ICashShopEntry from '@/models/items/ICashShop';

export default Vue.extend({
    components: {
        ItemIconTooltip,
    },
    props: {
        entry: {
            type: Object as () => ICashShopEntry,
            required: true,
        },
        origin: {
            type: String,
            default: '',
        },
        //  Package contents are usually only sold via their package — their
        //  individual sale status is noise there.
        hideSaleStatus: {
            type: Boolean,
            default: false,
        },
        //  Package-only members carry price 0; hide the meaningless "0 QC".
        hideZeroPrice: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        techMode(): boolean {
            return this.$store.state.techMode;
        },
        isPackage(): boolean {
            //  Game rule: a cashpackagetable entry, not _ItemSort, marks packages.
            return this.entry.isPackage;
        },
    },
});
